$(document).ready(function(){
	createHeaderFooter();
});

function createHeaderFooter() {
	// without using headerSeparator footerSeparator
	if ($('.footerSeparator').length == 0 && $('.headerSeparator').length == 0 && !$('header').length && !$('footer').length) {
		console.log("new header footer")
		$("body").prepend("<header/>");
		$("body").append("<footer/>");

		var _bodyCont = $('div[data-saaselementtype="Body Container"]').parent();

		//append to header
		_bodyCont.prevAll(".container,.container-fluid").appendTo($("header"));
		$("header").children().each(function (i, elem) { $("header").prepend(elem); });

		// append to footer
		_bodyCont.nextAll(".container,.container-fluid").appendTo($("footer"));

	} else {

		var headerFooterTimer = setInterval(function () {

			if ($('header').length && $('footer').length) {
				clearInterval(headerFooterTimer);
			} else {
				if ($('.footerSeparator').length && !$('footer').length) {
					$("body").append("<footer/>");
					$(".footerSeparator").closest(".container").nextAll(".container,.container-fluid").appendTo($("footer"));
					$(".footerSeparator").closest(".container").remove();
					//$('<div style="clear:both" />').insertBefore("footer");
				}

				if ($('.headerSeparator').length && !$('header').length) {
					$("<header/>").insertBefore($(".headerSeparator").closest(".container"));
					$(".headerSeparator").closest(".container").prevAll(".container,.container-fluid").appendTo("header");

					// correct/reverse the order of elements
					$("header").children().each(function (i, elem) { $("header").prepend(elem); });
					$(".headerSeparator").closest(".container").remove();
				}


				var winH = $(window).height();
				var headerH = $('header').height();
				var footerH = $('footer').height();
				var containerH = winH - headerH - footerH - 100;
				$('.saas-configurableelement[data-saaselementtype="Body Container"]').css('min-height', containerH);

			}
		}, 300);

	}
}
